export const MAX_SAFE_NEXT_NUMBER = Number.MAX_SAFE_INTEGER;

export function parseNextNumber(value) {
    if (value == null || String(value).trim() === '') {
        return 0;
    }
    const text = String(value).trim();
    if (!/^\d+$/.test(text)) {
        throw new Error('Next number must be a non-negative integer');
    }
    const number = Number(text);
    if (!Number.isSafeInteger(number) || number < 0) {
        throw new Error('Next number is outside the supported range');
    }
    return number;
}
